import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "search", "group", "groupCount", "groupToggle", "checkbox", "count" ]

  connect() {
    this.update()
  }

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase()

    this.groupTargets.forEach(group => {
      let matches = 0

      group.querySelectorAll(".checkbox").forEach(option => {
        const visible = option.textContent.toLowerCase().includes(term)
        option.classList.toggle("d-none", !visible)
        if (visible) matches++
      })

      group.classList.toggle("d-none", matches === 0)
      if (term) group.open = matches > 0
    })
  }

  toggleGroup(event) {
    event.preventDefault()

    const group = event.target.closest("details")
    const checkboxes = this.visibleCheckboxes(group)
    const check = !checkboxes.every(checkbox => checkbox.checked)

    checkboxes.forEach(checkbox => { checkbox.checked = check })
    group.open = true
    this.update()
  }

  clear() {
    this.checkboxTargets.forEach(checkbox => { checkbox.checked = false })
    this.update()
  }

  update() {
    this.groupTargets.forEach((group, index) => {
      const checkboxes = Array.from(group.querySelectorAll("input[type=checkbox]"))
      const selected = checkboxes.filter(checkbox => checkbox.checked).length

      this.groupCountTargets[index].textContent = `${selected} of ${checkboxes.length}`
      this.groupCountTargets[index].classList.toggle("text-muted", selected === 0)
      this.groupToggleTargets[index].textContent = selected === checkboxes.length ? "Select none" : "Select all"
    })

    const total = this.checkboxTargets.filter(checkbox => checkbox.checked).length
    this.countTarget.textContent = `${total} selected`
  }

  visibleCheckboxes(group) {
    return Array.from(group.querySelectorAll(".checkbox:not(.d-none) input[type=checkbox]"))
  }
}
